import { render, staticRenderFns } from "./b_Interpreters.vue?vue&type=template&id=6b985fd5&scoped=true&"
import script from "./b_Interpreters.vue?vue&type=script&lang=js&"
export * from "./b_Interpreters.vue?vue&type=script&lang=js&"
import style0 from "./b_Interpreters.vue?vue&type=style&index=0&id=6b985fd5&prod&lang=css&"
import style1 from "./b_Interpreters.vue?vue&type=style&index=1&id=6b985fd5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b985fd5",
  null
  
)

export default component.exports